import styles from './Posts.module.scss';
import useFetchHook from '../../hooks/useFecthHook';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

type PostProps = {
    title: string;
    date: string;
    abstract: string;
    content: string;
    url: string
};



export default function Post({ title, date, abstract, content,url }: PostProps): JSX.Element {
    
    return (
        <article className={styles.post}>
            <header className={styles.header}>
                <div className={styles.titleContainer}>
                    <h1 className={styles.title}>{title}</h1>
                        <img src={url} alt="Random Dog" className={styles.dogImage} />
                </div>
                <time className={styles.date}>{date}</time>
            </header>
            <div className={styles.content}>
                <p>{abstract}</p>
            </div>
        </article>
    );
}
